import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <ul>
            <li className="about-activity">
              Hi Everyone, I am <span className="purple">Olcay Tapan</span> from{" "}
              <span className="purple">Gothenburg, Sweden</span>.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> I have completed the Lexicon System Developer
              Python & IT-Security program, enhancing my skills in software
              development and IT security.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> I gained extensive experience in Java development
              through my roles and projects, including API development, backend
              services, and web applications.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> I worked at Acumant as a Software Developer,
              focusing on React-based solutions and contributing to dynamic web
              applications.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> Previously, I worked at Cubicl as a
              Frontend Developer, where I designed and improved user interfaces
              using React.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> I hold a bachelor's degree in Computer
              Engineering from Ahmet Yesevi University, completed in 2023.
            </li>
            <br />
            <li className="about-activity">
              <ImPointRight /> Earlier in my academic journey, I earned a Civil
              Engineering bachelor's degree in English and studied English for
              one year at Anadolu University.
            </li>
            <br />
            <li className="about-activity">
              Apart from coding, I enjoy engaging in various activities that
              fuel my creativity and curiosity!
            </li>
          </ul>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Walking in the Nature
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Board Games with Friends
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Destiny is in love with effort…"{" "}
          </p>
          <footer className="blockquote-footer">Yunus Emre</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
